import { KYCServiceState, KYCServiceType } from "consts/kyc";

export const KYC_SERVICE_TYPE_LABELS: Record<KYCServiceType, string> = {
    [KYCServiceType.FaceVerification]: 'Face Verif.',
    [KYCServiceType.IDVerification]: 'ID Verif.',
    [KYCServiceType.AMLVerification]: 'AML',
    [KYCServiceType.AddressVerification]: 'Address Verif.',
    [KYCServiceType.PhoneVerification]: 'Phone Verif.',
    [KYCServiceType.EIDVerification]: 'EID Verif.'
};

export const SERVICE_COLUMN_TYPES: ReadonlyArray<KYCServiceType> = [
    KYCServiceType.FaceVerification,
    KYCServiceType.IDVerification,
    KYCServiceType.AMLVerification,
    KYCServiceType.AddressVerification,
    KYCServiceType.PhoneVerification
];

export const KYC_SERVICE_STATE_LABELS: Record<KYCServiceState, string> = {
    [KYCServiceState.Off]: 'Off',
    [KYCServiceState.Strict]: 'Strict',
    [KYCServiceState.Soft]: 'Soft'
};

export const formatServiceState = (state: KYCServiceState | undefined) =>
    state === undefined ? KYC_SERVICE_STATE_LABELS[KYCServiceState.Off] : KYC_SERVICE_STATE_LABELS[state];

export const formatStatus = (isActive: unknown) =>
    Boolean(isActive) ? 'Active' : 'Inactive';
